module.exports = __webpack_public_path__ + "static/media/24UHCHR21.dc5d72b8.jpg";